/**
 * Suporte da administração da plataforma: fila de chamados (tasks) de gestores e treinadores.
 * Pendentes aparecem em caixas vermelho claro, no topo; a busca aceita o ID (SUP-000012 ou 12), o assunto e o
 * solicitante. A administração só vê o que o usuário escreveu/anexou no chamado; não acessa dados esportivos.
 */
import { useCallback, useEffect, useState } from "react";
import { api } from "../../api/client";
import type { SupportSummary } from "../../api/types";
import { PageHead } from "../../components/ui";
import { TicketBrowser, TicketView } from "../../components/SupportTickets";
import { t } from "../../i18n";

export function SupportInboxPage() {
  const [summary, setSummary] = useState<SupportSummary | null>(null);
  const load = useCallback(() => {
    api.get<SupportSummary>("/admin/support/summary").then(setSummary).catch(() => undefined);
  }, []);
  useEffect(() => {
    load();
    window.addEventListener("eapace:support-unread", load);
    const timer = window.setInterval(() => document.visibilityState === "visible" && load(), 30_000);
    return () => {
      window.removeEventListener("eapace:support-unread", load);
      window.clearInterval(timer);
    };
  }, [load]);

  return (
    <>
      <PageHead title={t("Suporte")} subtitle={t("Chamados de gestores e treinadores. Pendentes em destaque; conclua a task quando resolver.")} />
      {summary && (
        <dl className="ticket-stats">
          <div className="ticket-stat is-alert">
            <dt>{t("Pendentes")}</dt>
            <dd>{summary.open}</dd>
          </div>
          <div className="ticket-stat">
            <dt>{t("Aguardando resposta")}</dt>
            <dd>{summary.unread_tickets}</dd>
          </div>
          <div className="ticket-stat">
            <dt>{t("Solucionadas")}</dt>
            <dd>{summary.solved}</dd>
          </div>
        </dl>
      )}
      <div className="panel panel-body">
        <TicketBrowser
          admin
          listPath="/admin/support/tickets"
          hrefFor={(tp) => `/admin/suporte/${tp.id}`}
          emptyTitle={t("Nenhum chamado nesta situação.")}
          emptyHint={t("Quando um gestor ou treinador abrir um chamado em Ajuda, ele aparece aqui com o número SUP-….")}
          onData={() => load()}
        />
      </div>
    </>
  );
}

export function AdminTicketPage({ ticketId }: { ticketId: string }) {
  return <TicketView admin apiBase="/admin/support/tickets" ticketId={ticketId} backTo="/admin/suporte" backLabel={t("Fila de chamados")} />;
}
